<div class="alberta-button-listitem-leftButton">
  <ng-content></ng-content>
</div>
